import styled from 'styled-components';
import { Breakpoints } from '../../../../styled/constants';

export const AgencyFilterResultsWrapper = styled.div<{
  $isCurrentItemPage: boolean;
}>`
  padding: 0
    ${({ $isCurrentItemPage }) => ($isCurrentItemPage ? '20px' : '15px')};

  @media (min-width: ${Breakpoints.tablet}px) {
    padding: 0 40px;
  }

  @media (min-width: ${Breakpoints.desktop}px) {
    padding: 0
      ${({ $isCurrentItemPage }) => ($isCurrentItemPage ? '20px' : '40px')};
  }
`;
